/* Drifttid (Uptime) Page JavaScript */

let currentServer = null
let updateInterval = null
let serversCache = null
const CACHE_DURATION = 5 * 60 * 1000 // Cache servers list for 5 minutes

// Format milliseconds to human-readable duration with seconds
function formatDuration (ms) {
  const seconds = Math.floor(ms / 1000) % 60
  const minutes = Math.floor(ms / (1000 * 60)) % 60
  const hours = Math.floor(ms / (1000 * 60 * 60)) % 24
  const days = Math.floor(ms / (1000 * 60 * 60 * 24))

  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m ${seconds}s`
  } else if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`
  } else {
    return `${seconds}s`
  }
}

// Format timestamp to Swedish date format
function formatDate (timestamp) {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}`
}

// Get URL parameters
function getUrlParameter (name) {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}

// Update URL without reloading the page
function updateUrl (serverName) {
  const url = new URL(window.location)
  url.searchParams.set('server', serverName)
  window.history.pushState({}, '', url)
}

// Load servers list
async function loadServers () {
  try {
    let servers

    // Use cached data if available and fresh
    if (serversCache && Date.now() - serversCache.timestamp < CACHE_DURATION) {
      servers = serversCache.data
    } else {
      const response = await fetch('/api/servers')
      servers = await response.json()

      // Sort servers alphabetically once and cache
      servers.sort((a, b) => a.name.localeCompare(b.name, 'sv'))

      serversCache = {
        data: servers,
        timestamp: Date.now()
      }
    }

    const dropdown = document.getElementById('server-dropdown')
    dropdown.innerHTML = ''

    // Use DocumentFragment for better performance
    const fragment = document.createDocumentFragment()
    servers.forEach(server => {
      const option = document.createElement('option')
      option.value = server.ip
      option.textContent = server.name
      option.dataset.name = server.name
      fragment.appendChild(option)
    })
    dropdown.appendChild(fragment)

    // Select server from URL parameter or default to first
    const serverParam = getUrlParameter('server')
    let selectedIndex = 0

    if (serverParam) {
      const foundIndex = servers.findIndex(s =>
        s.name.toLowerCase() === serverParam.toLowerCase() ||
        s.ip === serverParam
      )
      if (foundIndex !== -1) {
        selectedIndex = foundIndex
      }
    }

    dropdown.selectedIndex = selectedIndex
    currentServer = servers[selectedIndex]

    // Load outages for selected server
    loadOutages(currentServer.ip)

    // Listen for dropdown changes
    dropdown.addEventListener('change', (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex]
      currentServer = {
        ip: selectedOption.value,
        name: selectedOption.dataset.name
      }
      updateUrl(currentServer.name)
      loadOutages(currentServer.ip)
    })
  } catch (error) {
    console.error('Error loading servers:', error)
    const dropdown = document.getElementById('server-dropdown')
    dropdown.innerHTML = '<option value="">Error loading servers</option>'
  }
}

// Update the uptime counter
function updateUptimeCounter (currentOutageStart, lastOutageEnd) {
  const counterElement = document.querySelector('.uptime-value')
  const descriptionElement = document.querySelector('.uptime-description')

  if (currentOutageStart) {
    // Server is currently down
    const downSince = Date.now() - currentOutageStart
    counterElement.textContent = formatDuration(downSince)
    counterElement.classList.add('offline')
    descriptionElement.textContent = 'nere sedan'
  } else {
    // Server is up - show time since last outage
    counterElement.classList.remove('offline')
    descriptionElement.textContent = 'sedan senaste driftproblemet'

    if (lastOutageEnd) {
      const timeSinceLastOutage = Date.now() - lastOutageEnd
      counterElement.textContent = formatDuration(timeSinceLastOutage)
    } else {
      // No outages recorded
      counterElement.textContent = 'Inga registrerade driftstopp'
    }
  }
}

// Load outages for a specific server
async function loadOutages (ip) {
  const outagesContainer = document.getElementById('outages-container')
  outagesContainer.innerHTML = '<p class="loading">Laddar...</p>'

  // Clear existing update interval
  if (updateInterval) {
    clearInterval(updateInterval)
    updateInterval = null
  }

  try {
    const response = await fetch(`/api/outages?ip=${encodeURIComponent(ip)}`)
    const data = await response.json()

    if (data.error) {
      outagesContainer.innerHTML = `<p class="no-outages">${data.error}</p>`
      return
    }

    const { outages, currentOutageStart } = data
    const lastOutageEnd = outages.length > 0 ? outages[0].end_time : null

    // Update the uptime counter
    updateUptimeCounter(currentOutageStart, lastOutageEnd)

    // Set up interval to update counter every second
    updateInterval = setInterval(() => {
      updateUptimeCounter(currentOutageStart, lastOutageEnd)
    }, 1000)

    // Display outages list
    if (outages.length === 0) {
      outagesContainer.innerHTML = '<p class="no-outages">Inga registrerade driftstopp</p>'
    } else {
      outagesContainer.innerHTML = ''

      outages.forEach(outage => {
        const outageElement = document.createElement('div')
        outageElement.className = 'outage-item'

        const startDate = formatDate(outage.start_time)
        const duration = formatDuration(outage.end_time - outage.start_time)

        outageElement.innerHTML = `
          <div class="outage-date">${startDate}</div>
          <div class="outage-duration">Varaktighet: ${duration}</div>
        `

        outagesContainer.appendChild(outageElement)
      })
    }
  } catch (error) {
    console.error('Error loading outages:', error)
    outagesContainer.innerHTML = '<p class="no-outages">Kunde inte ladda driftstopp</p>'
  }
}

// Initialize hamburger menu
function initHamburgerMenu () {
  const toggle = document.getElementById('hamburger-toggle')
  const nav = document.getElementById('hamburger-nav')

  if (toggle && nav) {
    toggle.addEventListener('click', (e) => {
      e.stopPropagation()

      // Position the menu below the button
      const rect = toggle.getBoundingClientRect()
      nav.style.top = (rect.bottom + 5) + 'px'
      nav.style.left = rect.left + 'px'

      nav.classList.toggle('active')
    })

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!toggle.contains(e.target) && !nav.contains(e.target)) {
        nav.classList.remove('active')
      }
    })
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  initHamburgerMenu()
  loadServers()
})

// Clean up interval when page is unloaded
window.addEventListener('beforeunload', () => {
  if (updateInterval) {
    clearInterval(updateInterval)
  }
})
